module.exports = __webpack_public_path__ + "img/00018.4a580ac2.webp";